import React, { useState, useEffect } from 'react';
import { Fab } from '@mui/material';
import logowhatsapp from 'assets/images/logo-whatsapp.png';
import { useToast } from 'legacyfrontend/hooks/useToast';
import ErrorSnackbar from 'legacyfrontend/components/ErrorSnackbar';
import useWhatsAppUrl from '../../hooks/useWhatsAppUrl';

const FloatingButton = ({ whatsappUrl, isBusiness, finalPhoneNumber }) => {
  const [isMounted, setIsMounted] = useState(false);
  const { toastState, hideToast } = useToast();

  useEffect(() => {
    setIsMounted(true);
  }, []);
  
  if (!isMounted || !finalPhoneNumber) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-[1200]">
      <Fab
        component="a"
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={isBusiness ? "Contactar por WhatsApp Business" : "Contactar por WhatsApp"}
        sx={{
          backgroundColor: '#25D366',
          transition: 'transform 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: '#25D366',
            transform: 'translateY(-4px)',
          }
        }}
      >
        <img 
          alt={isBusiness ? "Icono de WhatsApp Business" : "Icono de WhatsApp"} 
          src={logowhatsapp} 
          style={{ width: 32, height: 32 }} 
        />
      </Fab>

      <ErrorSnackbar
        open={toastState.open}
        message={toastState.message}
        severity={toastState.severity}
        onClose={hideToast}
      />
    </div>
  );
};

const ConnectedFloatingButtonGroup = () => {
  const whatsapp = useWhatsAppUrl();

  return <FloatingButton {...whatsapp} />;
};

const FloatingButtonGroup = ({ phoneNumber }) => {
  if (phoneNumber === undefined) {
    return <ConnectedFloatingButtonGroup />;
  }

  const normalizedPhoneNumber = String(phoneNumber).replace(/\D/g, '');

  return (
    <FloatingButton
      finalPhoneNumber={normalizedPhoneNumber}
      isBusiness={false}
      whatsappUrl={normalizedPhoneNumber ? `https://wa.me/${normalizedPhoneNumber}` : null}
    />
  );
};

export default FloatingButtonGroup;
